import { getTheme } from 'Utilities/dataHelpers';
import { NAVIGATION } from '../nav/types';
import { SET_PHONE_LANGUAGE } from './types';
function getInitialState() {
  return {
    osType: 'none',
    osVersion: 'none',
    appVersion: 'none',
    deviceId: '',
    installationId: '',
    theme: getTheme(),
    app: 'libre1',
    appHash: '',
    deviceManufacturer: 'none',
    deviceModel: 'none',
    country: '',
    phoneLanguage: ''
  };
}
export function envReducer(state = getInitialState(), action) {
  var _action$context$query, _action$context$query2, _action$context$query3, _action$context$query4, _action$context$query5, _action$context$query6, _action$context$query7, _action$context$query8, _action$context$query9, _action$context$query0, _action$context$query1;
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        osType: ((_action$context$query = action.context.query) === null || _action$context$query === void 0 ? void 0 : _action$context$query.osType) || state.osType,
        osVersion: ((_action$context$query2 = action.context.query) === null || _action$context$query2 === void 0 ? void 0 : _action$context$query2.osVersion) || state.osVersion,
        deviceId: ((_action$context$query3 = action.context.query) === null || _action$context$query3 === void 0 ? void 0 : _action$context$query3.deviceId) || state.deviceId,
        installationId: ((_action$context$query4 = action.context.query) === null || _action$context$query4 === void 0 ? void 0 : _action$context$query4.installationId) || state.installationId,
        appVersion: ((_action$context$query5 = action.context.query) === null || _action$context$query5 === void 0 ? void 0 : _action$context$query5.appVersion) || state.appVersion,
        theme: ((_action$context$query6 = action.context.query) === null || _action$context$query6 === void 0 ? void 0 : _action$context$query6.theme) || state.theme,
        app: ((_action$context$query7 = action.context.query) === null || _action$context$query7 === void 0 ? void 0 : _action$context$query7.app) || state.app,
        appHash: ((_action$context$query8 = action.context.query) === null || _action$context$query8 === void 0 ? void 0 : _action$context$query8.appHash) || state.appHash,
        deviceManufacturer: ((_action$context$query9 = action.context.query) === null || _action$context$query9 === void 0 ? void 0 : _action$context$query9.deviceManufacturer) || state.deviceManufacturer,
        deviceModel: ((_action$context$query0 = action.context.query) === null || _action$context$query0 === void 0 ? void 0 : _action$context$query0.deviceModel) || state.deviceModel,
        country: ((_action$context$query1 = action.context.query) === null || _action$context$query1 === void 0 ? void 0 : _action$context$query1.country) || state.country
      };
    case SET_PHONE_LANGUAGE:
      return {
        ...state,
        phoneLanguage: action.phoneLanguage
      };
    default:
      return state;
  }
}